export default {
  methods: {
    getExcelFields() {
      return {
        [this.$t("project.id")]: {
          field: "id",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("project.projectNo")]: {
          field: "title",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("cyclesForm.series")]: {
          field: "seriesInfo.title",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("project.createdDate")]: {
          field: "createdDate",
          callback: (value) => {
            return this.$date.format(value);
          },
        },
        [this.$t("project.updatedAt")]: {
          field: "updatedDate",
          callback: (value) => {
            return this.$date.format(value || new Date());
          },
        },
      };
    },
  },
};
